import * as React from 'react';
import styled from 'styled-components';
import { Box, Button, Space, Spinner, TextBody, TextHeading, } from '@ally/metronome-ui';
import { MobileApproveEscapeIntent, } from '@ally/transmitigator';
import { TrackingEvent } from '../../../../../constants';
import { LoginHeading } from '../../../Layout/Layout';
import { AllyLogoForMobilePhone } from '../../../Svgs/index';
import { RepickSkeletonLoader } from './RepickSkeletonLoader';
const StyledPhoneNumber = styled(TextHeading) `
  font-size: 48px;
`;
const StyledTextBody = styled(TextBody) `
  max-width: 500px;
`;
const AllyLogoAndMobileNumberContainer = styled(Box) `
  display: grid;
  grid-auto-rows: auto;
  align-items: flex-start;
  max-width: 450px;
`;
const AllyLogoContainer = styled(Box) `
  grid-column: 1;
  flex-direction: column;
  width: 98px;
  height: 137px;
`;
const AllyMobileNumberContainer = styled(Box) `
  grid-column: 2;
  flex-direction: column;
`;
const StyledSpinner = styled(Spinner) `
  margin-top: 7px;
  padding-bottom: 5px;
  margin-left: 10px;
`;
export const MobileApproveContent = ({ otpValue, handleRepick, handleResend, hostServices, logger, status, }) => {
    const [shouldShowSpinner, setShouldShowSpinner] = React.useState(false);
    const [shouldShowSkeletonLoader, setShouldShowSkeletonLoader,] = React.useState(false);
    const [escapeIntent, setEscapeIntent] = React.useState(null);
    React.useEffect(() => {
        logger === null || logger === void 0 ? void 0 : logger.track(TrackingEvent.TransmitMobileApproveLoad);
        hostServices === null || hostServices === void 0 ? void 0 : hostServices.analytics.trackPageView({
            eventType: 'pageview',
            pageName: 'AOS:Login:Push Verification',
        });
    }, []);
    const onClickRepick = () => {
        logger === null || logger === void 0 ? void 0 : logger.track(TrackingEvent.TransmitMobileApproveRepick);
        setEscapeIntent(MobileApproveEscapeIntent.Repick);
        handleRepick();
    };
    const onClickResend = () => {
        logger === null || logger === void 0 ? void 0 : logger.track(TrackingEvent.TransmitMobileApproveResend);
        setEscapeIntent(MobileApproveEscapeIntent.Resend);
        handleResend();
    };
    React.useEffect(() => {
        if (status === 'Loading') {
            switch (escapeIntent) {
                case MobileApproveEscapeIntent.Repick:
                    setShouldShowSkeletonLoader(true);
                    break;
                case MobileApproveEscapeIntent.Resend:
                    setShouldShowSpinner(true);
                    break;
                default:
                // nothing
            }
        }
        else {
            // reset
            setShouldShowSpinner(false);
            setShouldShowSkeletonLoader(false);
        }
    }, [status, escapeIntent]);
    return (React.createElement(React.Fragment, null, shouldShowSkeletonLoader ? (React.createElement(RepickSkeletonLoader, null)) : (React.createElement(React.Fragment, null,
        React.createElement(LoginHeading, { title: "Check your device." }),
        React.createElement(Space, { mb: "lg" },
            React.createElement(StyledTextBody, { size: "sm", tag: "p" }, "Open the notification and select the matching number to confirm it's you.")),
        React.createElement(AllyLogoAndMobileNumberContainer, null,
            React.createElement(AllyLogoContainer, null,
                React.createElement(AllyLogoForMobilePhone, null)),
            React.createElement(AllyMobileNumberContainer, null,
                React.createElement(Space, { mb: "sm" }, shouldShowSpinner ? (React.createElement(StyledSpinner, null)) : (React.createElement(StyledPhoneNumber, { size: "lg", tag: "h2" }, otpValue))),
                React.createElement(Button, { mb: "sm", text: "Confirm another way", onClick: onClickRepick, variant: "link", allytmln: "confirmAnotherWay" }),
                React.createElement(TextBody, { size: "sm", tag: "p" },
                    "If you haven't received a notification yet, we can",
                    ' ',
                    React.createElement(Button, { text: "resend it.", onClick: onClickResend, variant: "link", allytmln: "resendIt" }))))))));
};
//# sourceMappingURL=MobileApproveContent.js.map